import { render } from "./App.vue?vue&type=template&id=d9350a1c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d9350a1c&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__